import * as React from 'react';
import { BasePureComponent } from '../BaseComponent';

interface IAddendumDataIndirizzi {
    Data: string;
    RenderFormField: any;
}

export class AddendumDataIndirizzi extends BasePureComponent<IAddendumDataIndirizzi> {
    public constructor(props: any) {
        super(props);
    }

    public render() {
        const data = JSON.parse(this.props.Data);
        const elementGroup = [];

        for (let key in data) {
            elementGroup.push({
                CampoAppendice: key,
                Etichetta: key,
                ValoreAppendice: data[key]
            });
        }
        return elementGroup.map(item => this.props.RenderFormField(item));
    }
}



// WEBPACK FOOTER //
// ./src/components/AddendumList/AddendumDataIndirizzi.tsx